import _defineProperty from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";
import qs from "qs";
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import SessionStorage from 'quasar/src/plugins/SessionStorage.js';;

var UtilityAllowances =
/*#__PURE__*/
function () {
  function UtilityAllowances() {
    _classCallCheck(this, UtilityAllowances);
  }

  _createClass(UtilityAllowances, null, [{
    key: "CreateUtilityAllowance",
    value: function CreateUtilityAllowance(utilityAllowance) {
      return axios.post("api/UtilityAllowances/CreateUtilityAllowance", utilityAllowance);
    }
  }, {
    key: "CreateUtilityAllowanceProjectRoomType",
    value: function CreateUtilityAllowanceProjectRoomType(utilityAllowanceId, projectRoomTypeId, comments, utilityAllowance, unitTypeId, source, rentControllingAuthorityId) {
      return axios.post("api/UtilityAllowances/CreateUtilityAllowanceProjectRoomType", {
        UtilityAllowanceId: utilityAllowanceId,
        ProjectRoomTypeId: projectRoomTypeId,
        Comments: comments,
        UtilityAllowance: utilityAllowance,
        UnitTypeId: unitTypeId,
        Source: source,
        RentControllingAuthorityId: rentControllingAuthorityId
      });
    }
  }, {
    key: "UpdateUtilityAllowanceProjectRoomType",
    value: function UpdateUtilityAllowanceProjectRoomType(utilityAllowanceId, utilityAllowanceProjectRoomTypeId, comments, utilityAllowance, unitTypeId, source, rentControllingAuthorityId) {
      var _axios$patch;

      return axios.patch("api/UtilityAllowances/UpdateUtilityAllowanceProjectRoomType", (_axios$patch = {
        UtilityAllowanceId: utilityAllowanceId,
        UtilityAllowanceProjectRoomTypeId: utilityAllowanceProjectRoomTypeId,
        Comments: comments
      }, _defineProperty(_axios$patch, "UtilityAllowanceId", utilityAllowanceId), _defineProperty(_axios$patch, "UtilityAllowance", utilityAllowance), _defineProperty(_axios$patch, "UnitTypeId", unitTypeId), _defineProperty(_axios$patch, "Source", source), _defineProperty(_axios$patch, "RentControllingAuthorityId", rentControllingAuthorityId), _axios$patch));
    }
  }, {
    key: "UpdateUtilityAllowance",
    value: function UpdateUtilityAllowance(utilityAllowance) {
      return axios.patch("api/UtilityAllowances/UpdateUtilityAllowance", utilityAllowance);
    }
  }, {
    key: "GetProjectRoomTypes",
    value: function GetProjectRoomTypes(projectId) {
      return axios.get("api/UtilityAllowances/GetProjectRoomTypes", {
        params: {
          projectId: projectId
        }
      });
    }
  }, {
    key: "GetRequiredUARows",
    value: function GetRequiredUARows(projectId) {
      return axios.get("api/UtilityAllowances/GetRequiredUARows", {
        params: {
          projectId: projectId
        }
      });
    }
  }, {
    key: "GetProjectRoomTypesUnitCount",
    value: function GetProjectRoomTypesUnitCount(projectRoomTypeId) {
      return axios.get("api/UtilityAllowances/GetProjectRoomTypesUnitCount", {
        params: {
          projectRoomTypeId: projectRoomTypeId
        }
      });
    }
  }, {
    key: "GetUtilityAllowances",
    value: function GetUtilityAllowances(projectId) {
      return axios.get("api/UtilityAllowances/GetUtilityAllowances", {
        params: {
          projectId: projectId
        }
      });
    }
  }, {
    key: "GetUtilityAllowancesRoomTypes",
    value: function GetUtilityAllowancesRoomTypes(utilityAllowanceId, projectId, isNew) {
      return axios.get("api/UtilityAllowances/getUtilityAllowancesRoomTypes", {
        params: {
          utilityAllowanceId: utilityAllowanceId,
          projectId: projectId,
          isNew: isNew
        }
      });
    }
  }, {
    key: "GetUtilityAllowanceHistory",
    value: function GetUtilityAllowanceHistory(projectId, numQuarters) {
      return axios.get("/api/UtilityAllowances/GetUtilityAllowancesHistory/".concat(projectId, "/").concat(numQuarters));
    }
  }, {
    key: "GetUtilityAllowanceById",
    value: function GetUtilityAllowanceById(utilityAllowanceId) {
      return axios.get("api/UtilityAllowances/GetUtilityAllowanceById", {
        params: {
          utilityAllowanceId: utilityAllowanceId
        }
      });
    }
  }, {
    key: "GetPreviousUtilityAllowance",
    value: function GetPreviousUtilityAllowance(utilityAllowanceId, projectId) {
      return axios.get("api/UtilityAllowances/GetPreviousUtilityAllowance", {
        params: {
          utilityAllowanceId: utilityAllowanceId,
          projectId: projectId
        }
      });
    }
  }, {
    key: "GetUnitTypes",
    value: function GetUnitTypes() {
      return axios.get("api/UtilityAllowances/GetUnitTypes");
    }
  }, {
    key: "GetSources",
    value: function GetSources() {
      return axios.get("api/UtilityAllowances/GetSources");
    }
  }, {
    key: "GetAllRoomTypes",
    value: function GetAllRoomTypes() {
      return axios.get("api/UtilityAllowances/GetAllRoomTypes");
    }
  }, {
    key: "CreateProjectRoomType",
    value: function CreateProjectRoomType(roomTypesId, count, projectId, specialNeedsCount) {
      return axios.post("api/UtilityAllowances/CreateProjectRoomType", {
        RoomTypeId: roomTypesId,
        Count: count,
        ProjectId: projectId,
        SpecialNeedsCount: specialNeedsCount
      });
    }
  }, {
    key: "DeleteUtilityAllowanceProjectRoomType",
    value: function DeleteUtilityAllowanceProjectRoomType(utilityAllowanceProjectRoomTypeId) {
      return axios.delete("/api/UtilityAllowances/DeleteUtilityAllowanceProjectRoomType", {
        params: {
          utilityAllowanceProjectRoomTypeId: utilityAllowanceProjectRoomTypeId
        }
      });
    }
  }, {
    key: "UpdateStatus",
    value: function UpdateStatus(UtilityAllowancesId, StatusId) {
      return axios.post("api/UtilityAllowances/UpdateStatus/".concat(UtilityAllowancesId, "/").concat(StatusId));
    }
  }]);

  return UtilityAllowances;
}();

export { UtilityAllowances as default };